import React, { useEffect, createElement } from 'react';
import { StickyNav } from './components/StickyNav';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { OldSolutions } from './components/OldSolutions';
import { Mechanism } from './components/Mechanism';
import { Benefits } from './components/Benefits';
import { Qualification } from './components/Qualification';
import { ProductIncludes } from './components/ProductIncludes';
import { Bonuses } from './components/Bonuses';
import { Objection } from './components/Objection';
import { Upsell } from './components/Upsell';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
import { SalesToast } from './components/SalesToast';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization — robust version
    if (typeof window === 'undefined') return;
    // Initialize fbq function immediately (queues events until script loads)
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    // Load the fbevents.js script
    if (!document.getElementById('fb-pixel-script')) {
      const script = document.createElement('script');
      script.id = 'fb-pixel-script';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    // Fire init + PageView (queued if script hasn't loaded yet)
    window.fbq('init', '1221158382812131');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#FAFAF8] text-[#1A1A1A]" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1221158382812131&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <StickyNav data-id="element-3" />
      <SalesToast data-id="element-4" />
      <main data-id="element-5">
        <Hero data-id="element-6" />
        <PainPoints data-id="element-7" />
        <OldSolutions data-id="element-8" />
        <Mechanism data-id="element-9" />
        <Benefits data-id="element-10" />
        <Qualification data-id="element-11" />
        <ProductIncludes data-id="element-12" />
        <Bonuses data-id="element-13" />
        <Objection data-id="element-14" />
        <Upsell data-id="element-15" />
        <ClosingCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}